/** @format */

export interface label {
	label: string;
	value: string;
}

export interface RuleDetail {
	field: string;
	operator?: string;
	value?: string | string[];
}

export interface Field {
	label: string;
	value: string;
	type: string;
	isMultiple?: boolean;
	params?: label[];
}

export interface Rules {
	rules: string;
	condition: RuleDetail[];
	conditions?: Rules[];
}

export interface TreeData {
	label: string;
	value: string;
	type: string;
	children?: TreeData[];
}

export const getFieldOperator = (type) => {
	if (type === 'input-number' || type === 'datetime') {
		return [
			{
				label: '等于',
				value: '===',
			},
			{
				label: '不等于',
				value: '!==',
			},
			{
				label: '小于',
				value: '<',
			},
			{
				label: '大于',
				value: '>',
			},
			{
				label: '小于等于',
				value: '<=',
			},
			{
				label: '大于等于',
				value: '>=',
			},
			{
				label: '为空',
				value: 'empty',
			},
			{
				label: '不为空',
				value: '!empty',
			},
		];
	} else {
		return [
			{
				label: '等于',
				value: '===',
			},
			{
				label: '不等于',
				value: '!==',
			},
			{
				label: '不包含',
				value: '!includes',
			},
			{
				label: '包含',
				value: 'includes',
			},
			{
				label: '为空',
				value: 'empty',
			},
			{
				label: '不为空',
				value: '!empty',
			},
		];
	}
};

export const getRulesStatus = (data, treeData, rules) => {
	let ret = true;
	const list: any = [];
	for (let i = 0; i < rules.condition?.length; i++) {
		const condition = rules.condition[i];
		if (condition.field.startsWith('$') && condition.field.endsWith('$')) {
			list.push(getRuleStatus(condition.field.slice(1, -1), {}, condition));
		} else {
			const field = findObjByCode(condition.field, treeData);
			list.push(getRuleStatus(data[condition.field], field, condition));
		}
	}
	for (let i = 0; i < rules.conditions?.length; i++) {
		const condition = rules.conditions[i];
		const out = getRulesStatus(data, treeData, condition);
		list.push(out);
	}

	for (let i = 0; i < list.length; i++) {
		if (i === 0) {
			ret = list[i];
		} else {
			if (rules.rules === 'and') {
				ret = ret && list[i];
			} else {
				ret = ret || list[i];
			}
		}
	}
	return ret;
};

export function findObjByCode(code, treeArr) {
	for (const node of treeArr) {
		if (node.value === code) {
			return node;
		}
		if (node.children && node.children.length > 0) {
			const result = findObjByCode(code, node.children);
			if (result) {
				return result;
			}
		}
	}
	return null;
}

const getStatusByOperation = (data, operation, value) => {
	let result = false;
	switch (operation) {
		case '===':
			if (Array.isArray(data)) {
				result =
					data.length === value.length &&
					data.every((a) => value.some((b) => a === b)) &&
					value.every((_b) => data.some((_a) => _a === _b));
			} else {
				result = data === value;
			}
			break;
		case '!==':
			if (Array.isArray(data)) {
				result = !(
					data.length === value.length &&
					data.every((a) => value.some((b) => a === b)) &&
					value.every((_b) => data.some((_a) => _a === _b))
				);
			} else {
				result = data !== value;
			}
			break;
		case '!includes':
			if (Array.isArray(data)) {
				result = !value.every((element) => data.includes(element));
			} else {
				result = !data.includes(value);
			}
			break;
		case 'includes':
			console.log(222);
			if (Array.isArray(data)) {
				result = value.every((element) => data.includes(element));
			} else {
				console.log(111);
				result = data.includes(value);
			}
			break;
		case '<':
			result = data < value;
			break;
		case '>':
			result = data > value;
			break;
		case '<=':
			result = data <= value;
			break;
		case '>=':
			result = data >= value;
			break;
		case 'empty':
			if (Array.isArray(data)) {
				result = data.length === 0 ? true : false;
			} else {
				result = data === '' ? true : false;
			}
			break;
		case '!empty':
			if (Array.isArray(data)) {
				result = data.length !== 0 ? true : false;
			} else {
				result = data !== '' ? true : false;
			}
			break;
	}
	return result;
};

const getRuleStatus = (data, field, condition) => {
	const { operator, value } = condition;
	if (field?.type === 'input-number') {
		if (operator === 'empty' || operator === '!empty') {
			return getStatusByOperation(data || '', operator, value || '');
		} else {
			return getStatusByOperation(+(data || 0), operator, +(value || 0));
		}
	} else {
		if (field?.isMultiple) {
			return getStatusByOperation((data && data.split(',')) || [], operator, (value && value.split(',')) || []);
		} else {
			return getStatusByOperation(data || '', operator, value || '');
		}
	}
};
